export default "__VITE_ASSET__n2ywlrT7__"